import React, { useState, useEffect } from "react";
import api from "../api/homeapi";
import { StaffFrame } from "./DashboardShared";

const C = { green:"#006B3C", greenLt:"#E8F5EE", grayBd:"#E0E0E0", text:"#1A1A1A", textSub:"#666" };

export default function AdminRevenue() {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/admin/revenue-chart").then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  // Agrégation par date
  const byDate = data.reduce((acc, d) => {
    acc[d.date] = (acc[d.date] || 0) + d.amount;
    return acc;
  }, {});

  const totalRevenue = data.reduce((s, d) => s + d.amount, 0);
  const byClass = data.reduce((acc, d) => {
    if (d.class) acc[d.class] = (acc[d.class] || 0) + d.amount;
    return acc;
  }, {});

  const CLASS_COLORS = { ECONOMIQUE:"#1565C0", PREMIERE:"#6A1B9A", VIP:"#E65100" };

  return (
    <StaffFrame>
      <div style={{ padding:28 }}>
        <h1 style={{ margin:"0 0 4px", fontSize:22, fontWeight:800 }}>Recettes SETRAG</h1>
        <p style={{ margin:"0 0 28px", color:C.textSub, fontSize:13 }}>Suivi financier des ventes de billets</p>

        {loading ? (
          <div style={{ textAlign:"center", padding:60, color:C.textSub }}>Chargement...</div>
        ) : (
          <>
            {/* KPI */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:16, marginBottom:32 }}>
              <div style={{ background:"#fff", borderRadius:14, padding:24, border:`1px solid ${C.grayBd}` }}>
                <div style={{ fontSize:12, color:C.textSub, fontWeight:600, marginBottom:4 }}>RECETTES TOTALES</div>
                <div style={{ fontSize:28, fontWeight:800, color:C.green }}>{totalRevenue.toLocaleString("fr-FR")} FCFA</div>
              </div>
              {Object.entries(byClass).map(([cls, amount]) => (
                <div key={cls} style={{ background:"#fff", borderRadius:14, padding:24, border:`1px solid ${C.grayBd}` }}>
                  <div style={{ fontSize:12, color:C.textSub, fontWeight:600, marginBottom:4 }}>{cls}</div>
                  <div style={{ fontSize:22, fontWeight:800, color:CLASS_COLORS[cls] || C.green }}>{amount.toLocaleString("fr-FR")} FCFA</div>
                </div>
              ))}
            </div>

            {/* Par jour */}
            <div style={{ background:"#fff", borderRadius:14, padding:24, border:`1px solid ${C.grayBd}`, marginBottom:24 }}>
              <h2 style={{ margin:"0 0 20px", fontSize:16, fontWeight:700 }}>Recettes par jour</h2>
              {Object.keys(byDate).length === 0 ? (
                <div style={{ textAlign:"center", padding:40, color:C.textSub }}>Aucune donnée disponible.</div>
              ) : (
                <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                  {Object.entries(byDate).sort(([a],[b]) => b.localeCompare(a)).map(([date, amount]) => {
                    const pct = Math.round((amount / totalRevenue) * 100);
                    return (
                      <div key={date} style={{ display:"flex", alignItems:"center", gap:12 }}>
                        <div style={{ width:90, fontSize:12, color:C.textSub, flexShrink:0 }}>{date}</div>
                        <div style={{ flex:1, background:"#F5F5F5", borderRadius:6, height:22, overflow:"hidden" }}>
                          <div style={{ width:`${pct}%`, height:"100%", background:`linear-gradient(90deg, ${C.green}, #1E7A4A)`, borderRadius:6, display:"flex", alignItems:"center", paddingLeft:8, minWidth:40 }}>
                            <span style={{ fontSize:11, color:"#fff", fontWeight:600 }}>{pct}%</span>
                          </div>
                        </div>
                        <div style={{ width:130, fontSize:13, fontWeight:700, textAlign:"right", flexShrink:0 }}>
                          {amount.toLocaleString("fr-FR")} FCFA
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </StaffFrame>
  );
}
